import type { PropsBase } from 'react-day-picker';

function getDisabledDates(validDates?: { from?: Date; to?: Date }): PropsBase['disabled'] {
  if (validDates?.from && validDates?.to) {
    return {
      before: validDates.from,
      after: validDates.to
    };
  }

  if (validDates?.from) {
    return {
      before: validDates.from
    };
  }

  if (validDates?.to) {
    return {
      after: validDates.to
    };
  }

  return undefined;
}

function getStartMonth(from?: Date): Date | undefined {
  if (!from) {
    return undefined;
  }

  const start = new Date(from);
  start.setDate(1);
  start.setHours(0, 0, 0, 0);
  return start;
}

function getEndMonth(to?: Date): Date | undefined {
  if (!to) {
    return undefined;
  }

  const end = new Date(to);
  end.setMonth(end.getMonth() + 1);
  end.setDate(0);
  end.setHours(0, 0, 0, 0);
  return end;
}

// getDisabledProps returns the various DayPicker props we care about for our UX when we have validDates enabled.
export function getDisabledProps(validDates?: { from?: Date; to?: Date }): Pick<PropsBase, 'disabled' | 'startMonth' | 'endMonth'> | undefined {
  if (!validDates) {
    return undefined;
  }

  return {
    disabled: getDisabledDates(validDates),
    startMonth: getStartMonth(validDates.from),
    endMonth: getEndMonth(validDates.to)
  };
}
